import { Typography } from "@/design-system/Atoms";
import { ROUTES } from '@/routes/routes.config';
import BreadcrumbsContainer from "../BreadcrumbsContainer";

const CheckoutHeaderSection = () => {
    const checkoutPageBreadcrumbs = [
        { label: "Home", href: ROUTES.HOME },
        { label: "Checkout", isActive: true },
    ];

    return (
        <section className="bg-[#f6f7f9] pb-[3.75rem] pt-[96px] bg-[url('/images/bg-checkout.svg')] bg-no-repeat bg-cover bg-top overflow-hidden">
            <div className="container mx-auto px-4">
                <BreadcrumbsContainer items={checkoutPageBreadcrumbs} className="" />
                <Typography variant="sectionHeading" className="mt-10">Checkout</Typography>
            </div>
        </section>
    );
};

export default CheckoutHeaderSection;
